import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { FormControl, Button, Modal } from "react-bootstrap";
import CurrencyInput from "react-currency-input"
import { notification } from "antd"

import { CSOSN } from "./data"


import { api, getBranchOwner, get, post, put } from "@config";
import { setLoading } from "@inspinia-react/actions";
import { checkIfBranchExists, decimalFormat } from "../../../../../utils";

class TemplateICMS extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {
        name: "",
        orig: "",
        csosn: ""
      },
      show: false,
      allow: false,
      fields: [
        {
          display: 'Mod. BC do ICMS (Modalidade de determinação)',
          key: 'mod_bc',
          as: "select",
          default: "0",
          options: ["Margem Valor Agregado (%)", "Pauta (Valor)", "Preço Tabelado Máx. (valor)", "Valor da operação"]
        },
        {
          display: 'Modalidade de determinação da BC do ICMS ST',
          key: 'mod_bc_st',
          as: "select",
          options: ["Preço tabelado ou máximo sugerido", "Lista Negativa (valor)", "Lista Positiva (valor)", "Lista Neutra (valor)", "Margem Valor Agregado (%)", "Pauta (valor)", "Valor da Operação"]
        },
        {
          display: "Alíquota de ICMS (%)",
          key: "p_icms"
        },
        {
          display: "Alíquota do imposto do ICMS ST",
          key: "p_icms_st"
        },
        {
          display: "Percentual da Redução de BC",
          key: "p_red_bc"
        },
        {
          display: "Percentual da Redução de BC ST",
          key: "p_red_bc_st"
        },
        {
          display: "Alíquota aplicável de cálculo do crédito (Simples Nacional)",
          key: "p_cred_sn"
        },
        {
          display: "Percentual da margem de valor Adicionado do ICMS ST",
          key: "p_mva_st"
        },
        {
          display: "Base de Cálculo",
          key: "bc_icms",
          not_percent: true
        },
        {
          display: "Valor do ICMS",
          key: "v_icms",
          not_percent: true
        },
      ],
      errs: []
    }
    this._showModal = this._showModal.bind(this)
    this._closeModal = this._closeModal.bind(this)
    this._handleChange = this._handleChange.bind(this)
    this._onSave = this._onSave.bind(this)
    this._successPayload = this._successPayload.bind(this)
    this._errorPayload = this._errorPayload.bind(this)
  }

  _enableObj() {
    const { icms: data } = this.props
    this.setState({ ...this, data })
    setTimeout(() => {
      this._calculateICMSValue()
    }, 100)
  }

  _onSave() {
    if (this.validate()) {
      const { data } = this.state
      this.setState({ ...this, data })
      this.request()
    }
  }

  _calculateICMSValue() {
    const { data } = this.state
    const bc = parseFloat(data["bc_icms"]) || 0
    const aliq = parseFloat(data["p_icms"] || 0) / 100
    data["v_icms"] = decimalFormat((bc * aliq), 2)
    console.log(data["v_icms"])

    this.setState({ ...this, data })
  }

  _successPayload(icms) {
    notification.open({
      message: !this.props.icms ? "Criado com sucesso!" : "Atualizado com sucesso!",
      type: "success"
    })

    this.setState({ ...this, show: false, data: {} })
    this.props.setLoading(false)
    this.props.onSuccess(icms)
  }

  _errorPayload() {
    notification.open({
      message: "Erro",
      type: "error"
    })
    this.props.setLoading(false)
  }

  _handleChange(ee, doubleValue, e) {
    if (ee.target) {
      e = ee
    } else {
      e.target.value = doubleValue
    }
    const { data } = this.state
    let { name: key, value } = e.target

    if (doubleValue > 100) {
      value = 100
    }

    data[key] = value
    this.setState({ ...this, data })
    if (["p_icms", "bc_icms"].includes(key)) {
      setTimeout(() => {
        this._calculateICMSValue()
      }, 100)
    }
  }

  _showModal() {
    this.setState({ ...this, show: true })
  }
  _closeModal() {
    this.setState({ ...this, show: false })
  }

  validate() {
    let errs = []

    const { name, orig, csosn } = this.state.data
    if (!name || name.length < 3) {
      errs.push("Nome inválido (mín. 3 caract.)")
    }
    if (!orig && orig !== 0) {
      errs.push("Selecione uma origem")
    }
    if (!csosn) {
      errs.push("Selecione um csosn")
    }
    this.setState({ ...this, errs })
    return !errs.length
  }

  componentDidMount() {
    checkIfBranchExists()
    if (this.props.icms) {
      this._enableObj()
      this.request = () => {
        put(`${api.icms}${this.props.icms.id}/?branch_owner=${getBranchOwner().id}`, this.state.data, this._successPayload, this._errorPayload);
      }
    } else {
      this.request = () => {
        post(`${api.icms}?branch_owner=${getBranchOwner().id}`, this.state.data, this._successPayload, this._errorPayload)
      }
    }
  }

  render() {
    return <React.Fragment>
      <button onClick={this._showModal} className="btn btn-sm btn-outline btn-primary dim">
        {this.props.create ? <React.Fragment>
          <i className="fa fa-plus"></i> Criar
        </React.Fragment> : <i className="fa fa-edit"></i>}
      </button>
      <Modal show={this.state.show} size="lg" onHide={this._closeModal}>
        <Modal.Header closeButton>
          <h2>Template ICMS</h2>
        </Modal.Header>
        <Modal.Body>
          <ul>{this.state.errs.map((err, _) => <li key={_} className='text-danger'>{err}</li>)}</ul>
          <div className="form-group">
            <div className="form-label">
              Nome
            </div>
            <FormControl
              name="name"
              value={this.state.data["name"]}
              onChange={this._handleChange}
            />
          </div>
          <div className="form-group">
            <div className="form-label">
              Origem da Mercadoria*
            </div>
            <FormControl
              name="orig"
              defaultValue={this.state.data.orig}
              onChange={this._handleChange}
              as="select">
              <option value="">Selecione</option>
              {["Nacional", "Estrangeira"].map((option, index) => <option key={`tamplate-icms-field-option-orig-${index}`} value={index}>{option}</option>)}
            </FormControl>
          </div>
          <div className="form-group">
            <div className="form-label">
              CSOSN
            </div>
            <FormControl
              name="csosn"
              defaultValue={this.state.data.csosn}
              onChange={this._handleChange}
              as="select">
              <option value="">Selecione</option>
              {CSOSN.map((option, index) => <option key={`tamplate-icms-field-option-csosn-${index}`} value={option.value}>{option.value}={option.label}</option>)}
            </FormControl>
          </div>

          <button
            onClick={() => this.setState({ ...this, allow: !this.state.allow })}
            className='btn btn-link'
          >
            {this.state.allow ? "Esconder" : "Mostrar mais"}
          </button>

          <div className={this.state.allow ? "row" : "d-none"}>
            {
              this.state.fields.map((field, indexKey) => {
                return <div className="col-lg-6 col-sm-6 col-xs-12 mb-2" key={`map-tamplate-icms-field-${indexKey}`}>
                  <div className="form-grop" >
                    <div className="form-label">
                      {field.display}
                    </div>
                    {
                      field.as === "select"
                        ?
                        <FormControl
                          name={`${field.key}`}
                          defaultValue={field.default}
                          onChange={this._handleChange}
                          as="select">
                          <option value="">Selecione</option>
                          {field.options.map((option, index) => <option key={`tamplate-icms-field-option-${index}`} value={index}>{option}</option>)}
                        </FormControl>
                        :
                        <CurrencyInput
                          name={`${field.key}`}
                          value={this.state.data[field.key]}
                          onChange={this._handleChange}
                          className="form-control"
                        />
                    }
                  </div>
                </div>
              })
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={this._closeModal}>
            Cancelar
          </Button>
          <Button onClick={this._onSave}>
            Salvar
          </Button>
        </Modal.Footer>

      </Modal>
    </React.Fragment>
  }

}


const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setLoading,
    },
    dispatch
  );


export default connect(mapStateToProps, mapDispatchToProps)(TemplateICMS);



// WEBPACK FOOTER //
// ./src/components/pages/fiscal/taxes/template-icms/index.jsx